<div class="modal-header">
    <h5 class="modal-title">
        @if(currentLanguage == 'it_IT') {
            Guida all'Installazione della PWA
        }
        @else {
            PWA (Progressive Web App) Installation Guide
        }
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
</div>
<div class="modal-body">
    <div>
        <p>
            @if(currentLanguage == 'it_IT') {
                Le PWA (Progressive Web App) sono applicazioni web di nuova generazione che possono essere installate sul tuo dispositivo senza passare dall'App Store o dal Google Play Store. Occupano pochissimo spazio e funzionano anche offline.
            }
            @else {
                Progressive Web Apps (PWAs) are a new generation of web applications that can be installed directly onto your device without using the App Store or Google Play Store. They take up very little storage space and can even work offline.
            }
        </p>
        
        <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
                <a class="nav-link {{ currentSection == 'desktop' ? 'active' : ''}}" (click)="currentSection = 'desktop'">
                    @if(currentLanguage == 'it_IT') {
                        💻 PC e Mac (Desktop)
                    }
                    @else {
                        💻 PC & Mac (Desktop)
                    }
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link {{ currentSection == 'mobile' ? 'active' : ''}}" (click)="currentSection = 'mobile'">
                    @if(currentLanguage == 'it_IT') {
                        📱 Smartphone e Tablet (Mobile)
                    }
                    @else {
                        📱 Smartphones & Tablets (Mobile)
                    }
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link {{ currentSection == 'faq' ? 'active' : ''}}" (click)="currentSection = 'faq'">
                    @if(currentLanguage == 'it_IT') {
                        ❓ Domande Frequenti (FAQ)
                    }
                    @else {
                        ❓ Frequently Asked Questions (FAQ)
                    }
                </a>
            </li>
        </ul>

        <div>
            @if(currentSection == 'desktop') {
                @if(currentLanguage == 'it_IT') {
                    <p>Il browser consigliato per l'installazione su computer è <strong>Google Chrome</strong> o <strong>Microsoft Edge</strong>.</p>
                
                    <h5>Utilizzando Google Chrome / Microsoft Edge</h5>
                    <ol>
                        <li>Apri il browser e naviga sul sito web della nostra applicazione.</li>
                        <li>Guarda la <strong>barra degli indirizzi</strong> in alto a destra: vedrai un'icona a forma di computer con una freccia verso il basso (oppure un'icona col simbolo <strong>"+"</strong>).</li>
                        <li>Clicca sull'icona e seleziona <strong>"Installa"</strong> nel popup che compare.</li>
                        <li>L'applicazione si aprirà immediatamente in una finestra dedicata e troverai l'icona sul tuo desktop.</li>
                    </ol>
                
                    <p>
                        💡 <strong>Alternativa:</strong> Puoi installarla anche cliccando sui <strong>tre puntini in alto a destra</strong> del browser e selezionando la voce <strong>"Salva e condividi"</strong> &rarr; <strong>"Installa pagina come app"</strong> (o semplicemente "Installa [Nome App]").
                    </p>
                }
                @else {
                    <p>For the best installation experience on a computer, we recommend using <strong>Google Chrome</strong> or <strong>Microsoft Edge</strong>.</p>
        
                    <h5>Using Google Chrome / Microsoft Edge</h5>
                    <ol>
                        <li>Open your browser and navigate to our website.</li>
                        <li>Look at the <strong>address bar</strong> at the top right: you will see an icon shaped like a computer with a down arrow (or a <strong>"+"</strong> symbol icon).</li>
                        <li>Click the icon and select <strong>"Install"</strong> from the popup menu.</li>
                        <li>The application will immediately open in its own dedicated window, and a shortcut will be added to your desktop.</li>
                    </ol>

                    <p>
                        💡 <strong>Alternative Method:</strong> You can also install it by clicking the <strong>three vertical dots</strong> in the top-right corner of the browser, then selecting <strong>"Save and share"</strong> &rarr; <strong>"Install page as app"</strong> (or simply "Install [App Name]").
                    </p>
                }
            }

            @if(currentSection == 'mobile') {
                @if(currentLanguage == 'it_IT') {
                    <h5>Su Dispositivi Android (Google Chrome)</h5>
                    <ol>
                        <li>Apri <strong>Chrome</strong> e vai sul sito della nostra applicazione.</li>
                        <li>Spesso comparirà in automatico un banner in basso con la scritta <strong>"Aggiungi [Nome App] alla schermata Home"</strong>. Cliccaci sopra.</li>
                        <li>Se il banner non appare:
                            <ul>
                                <li>Tocca i <strong>tre puntini in alto a destra</strong> accanto alla barra degli indirizzi.</li>
                                <li>Seleziona la voce <strong>"Installa app"</strong> (o "Aggiungi a schermata Home").</li>
                            </ul>
                        </li>
                        <li>Conferma l'operazione. Troverai l'app insieme a tutte le altre sul tuo telefono.</li>
                    </ol>
                
                    <h5>Su Dispositivi iOS / iPhone e iPad (Safari)</h5>
                    <p><em>Nota: su iOS l'installazione è supportata principalmente tramite il browser nativo Safari.</em></p>
                    <ol>
                        <li>Apri <strong>Safari</strong> e naviga sul sito della nostra applicazione.</li>
                        <li>Tocca il pulsante <strong>"Condividi"</strong> (l'icona con il quadrato e la freccia che punta verso l'alto, situata in basso al centro dello schermo).</li>
                        <li>Scorri il menu verso il basso e seleziona la voce <strong>"Aggiungi alla schermata Home"</strong>.</li>
                        <li>Se vuoi, personalizza il nome dell'app e poi tocca <strong>"Aggiungi"</strong> in alto a destra. L'icona apparirà sulla tua Home screen come una normale app.</li>
                    </ol>
                }
                @else {
                    <h5>On Android Devices (Google Chrome)</h5>
                    <ol>
                        <li>Open <strong>Chrome</strong> and go to our website.</li>
                        <li>A banner will often automatically appear at the bottom saying <strong>"Add [App Name] to Home screen"</strong>. Tap it.</li>
                        <li>If the banner doesn't appear:
                            <ul>
                                <li>Tap the <strong>three dots</strong> in the top-right corner next to the address bar.</li>
                                <li>Select <strong>"Install app"</strong> (or "Add to Home screen").</li>
                            </ul>
                        </li>
                        <li>Confirm the installation. The app will now appear in your app drawer and Home screen.</li>
                    </ol>

                    <h5>On iOS Devices / iPhone & iPad (Safari)</h5>
                    <p><em>Note: On iOS, installation is primarily supported via the native Safari browser.</em></p>
                    <ol>
                        <li>Open <strong>Safari</strong> and go to our website.</li>
                        <li>Tap the <strong>"Share"</strong> button (the square icon with an arrow pointing upwards, located at the bottom center of the screen).</li>
                        <li>Scroll down the share sheet and select <strong>"Add to Home Screen"</strong>.</li>
                        <li>(Optional) Customize the name of the app, then tap <strong>"Add"</strong> in the top-right corner. The icon will appear on your Home screen just like a regular app.</li>
                    </ol>
                }
            }

            @if(currentSection == 'faq') {
                @if(currentLanguage == 'it_IT') {
                    <div class="mb-3">
                        <div class="mb-1">• L'app occupa molto spazio?</div>
                        <div>No, le PWA sono estremamente leggere (spesso meno di 1-2 MB) perché sfruttano il browser per funzionare.</div>
                    </div>
                
                    <div class="mb-3">
                        <div class="mb-1">• Come faccio ad aggiornarla?</div>
                        <div>Non c'è bisogno di andare in nessun negozio digitale. L'applicazione si aggiorna automaticamente ogni volta che la apri con una connessione internet attiva.</div>
                    </div>
                
                    <div class="mb-3">
                        <div>• Come si disinstalla?</div>
                        <div class="mb-1">
                            <strong>Su Mobile:</strong> Tieni premuta l'icona e seleziona "Elimina" o "Disinstalla".<br>
                            <strong>Su Desktop:</strong> Apri l'app, clicca sui tre puntini in alto a destra della finestra e seleziona "Disinstalla [Nome App]".
                        </div>
                    </div>
                }
                @else {
                    <div class="mb-3">
                        <div class="mb-1">• Does the app take up a lot of storage?</div>
                        <div>No, PWAs are extremely lightweight (often under 1–2 MB) because they rely on your browser architecture to run.</div>
                    </div>

                    <div class="mb-3">
                        <div class="mb-1">• How do I update the app?</div>
                        <div>You don't need to visit any app store. The application updates automatically in the background every time you open it with an active internet connection.</div>
                    </div>

                    <div class="mb-3">
                        <div class="mb-1">• How do I uninstall it?</div>
                        <div>
                            <strong>On Mobile:</strong> Long-press the icon and select "Remove App", "Delete", or "Uninstall".<br>
                            <strong>On Desktop:</strong> Open the app, click the three dots in the top-right corner of the app window, and select "Uninstall [App Name]".
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</div>
